module.exports = __webpack_public_path__ + "components/flag/static/square/us-8412fb0355c0a3f451a6bb9b26d4fd26.svg";